import clsx from 'clsx';
import Button from '../../Button/Button';
import { ButtonWidth } from '../../Button/consts';
import { ClickableAction } from '../../Clickable/consts';
import Icon from '../../Icon/Icon';
import type { PressFilterModalProps } from './interfaces';
import styles from './PressFilterModal.module.scss';

const PressFilterModal = ({
  visible = false,
  headline,
  onClose,
  onFilterReset,
  children,
}: PressFilterModalProps) => {
  return (
    <div className={clsx(styles.base, { [styles.visible]: visible })}>
      <div className={styles.header}>
        <span className={styles.headline}>{headline}</span>
        <Icon
          variant={'action/close'}
          size="iconSize24"
          className={styles.icon}
          onClick={onClose}
        />
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.content}>{children}</div>
        <div className={styles.footer}>
          <Button
            actionType={ClickableAction.Custom}
            width={ButtonWidth.Full}
            onClick={onClose}
            className={styles.button}
          >
            Filter anwenden
          </Button>
          <button className={styles.resetFilter} onClick={onFilterReset}>
            Alle Filter löschen
          </button>
        </div>
      </div>
    </div>
  );
};

export default PressFilterModal;
